import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ShareWeeklyConsolPlanningRoutingModule } from './share-weekly-consol-planning-routing.module';
import { ShareWeeklyConsolFormComponent } from './share-weekly-consol-form/share-weekly-consol-form.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AngularMaterialModule } from 'src/app/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatDialogModule } from '@angular/material/dialog';
import { DateAdapter } from '@angular/material/core';
import { ShareWeeklyPlanningDateAdapter } from './share-weekly-planning-date-adapter';
import { DatePipe } from '@angular/common';
import { ShareWeeklyConsolEmailComponent } from './share-weekly-consol-email/share-weekly-consol-email.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';


@NgModule({
  declarations: [
    ShareWeeklyConsolFormComponent,
    ShareWeeklyConsolEmailComponent
  ],
  imports: [
    CommonModule,
    ShareWeeklyConsolPlanningRoutingModule,
    SharedModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatChipsModule,
    MatIconModule,
    MatSelectModule,
  ],
     providers: [
      { provide: DateAdapter, useClass: ShareWeeklyPlanningDateAdapter },
      DatePipe
    ]
})
export class ShareWeeklyConsolPlanningModule { }
